/**
 * TaxServicesPage — iter-272 (Feb 2026)
 * =====================================
 * NEW hub under التحكم والمعلومات (منصة العملاء) → الخدمات الضريبية.
 * Uses the shared ServiceCatalogPage so the operator sees the SAME
 * cards + manage-required-documents flow used by every other admin
 * service catalog.
 *
 * Route:  /control/cloudgm/tax-services             → list
 *         /control/cloudgm/tax-services/:id         → detail
 */
import ServiceCatalogPage from './ServiceCatalogPage';

export default function TaxServicesPage() {
  return (
    <ServiceCatalogPage
      category="tax_services"
      titleAr="الخدمات الضريبية"
      titleEn="Tax Services"
      subtitleAr="إدارة الخدمات الضريبية والأوراق المطلوبة"
      subtitleEn="Manage tax services and required documents"
      accentColor="amber"
      backPath="/control/cloudgm"
      detailPathBase="/control/cloudgm/tax-services"
      testIdPrefix="tax-services"
      breadcrumb={[
        { labelAr: 'CLOUDGM FZ LLC', labelEn: 'CLOUDGM FZ LLC', path: '/dashboard?view=cloudgm' },
        { labelAr: 'منصة العملاء', labelEn: 'Customers Platform', path: '/dashboard?view=cloudgm&platform=customers' },
        { labelAr: 'التحكم والمعلومات (منصة العملاء)', labelEn: 'Control & Info (Customers)', path: '/control/cloudgm' },
        { labelAr: 'الخدمات الضريبية', labelEn: 'Tax Services' },
      ]}
    />
  );
}
